var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { Button, Col, Progress, Row, Statistic, Tooltip } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { AiFillPauseCircle, AiFillPlayCircle } from 'react-icons/ai';
import { ImStop } from 'react-icons/im';
import { Trans } from 'react-i18next';
import { observer } from 'mobx-react';
import { useStore } from '../../rootStore';
const styles = {
    button: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 4,
        height: '38 !important',
        backgroundColor: '#F5F5F5',
    },
    icon: {
        width: 20,
        height: 20,
    },
    iconResume: {
        // $primary_green
        fill: '#0FB878',
    },
};
const BulkProgressDisplay = ({ data, onStop, onPause, onResume, messageStopped, bulkId }) => {
    const { sent = 0, skipped = 0, failed = 0, totalClients, stopped, paused } = data;
    const percentage = Math.round(((sent + skipped + failed) / totalClients) * 100);
    // Component must observe loading state from the store here, not having prop passed
    const { wizardStore } = useStore();
    const isLoading = wizardStore.bulkPauseResumeLoading.get(bulkId) || false;
    const onPauseResume = () => __awaiter(void 0, void 0, void 0, function* () {
        if (paused) {
            yield onResume();
        }
        else {
            yield onPause();
        }
    });
    const resumePauseIcon = paused ? (React.createElement(AiFillPlayCircle, { style: Object.assign(Object.assign({}, styles.icon), styles.iconResume) })) : (React.createElement(AiFillPauseCircle, { style: styles.icon }));
    return (React.createElement("div", null,
        React.createElement(Row, { gutter: 16 },
            React.createElement(Col, { flex: "120px" },
                React.createElement(Progress, { percent: percentage, type: "circle" })),
            React.createElement(Col, { flex: "auto" },
                React.createElement(Statistic, { title: React.createElement(Trans, { i18nKey: "bulkModalTotal" }), value: totalClients }),
                React.createElement(Statistic, { title: React.createElement(Trans, { i18nKey: "bulkModalSent" }), prefix: React.createElement(CheckCircleOutlined, null), value: sent || 0 })),
            React.createElement(Col, { flex: "auto" },
                React.createElement(Statistic, { title: React.createElement(Trans, { i18nKey: "bulkModalSkipped" }), prefix: React.createElement(ExclamationCircleOutlined, null), value: skipped || 0 }),
                React.createElement(Statistic, { title: React.createElement(Trans, { i18nKey: "bulkModalFailed" }), prefix: React.createElement(CloseCircleOutlined, null), value: failed || 0 }))),
        React.createElement(Row, { gutter: 12, style: { marginTop: 12 } },
            React.createElement(Col, { span: 12 },
                React.createElement(Tooltip, { title: stopped ? messageStopped : '' },
                    React.createElement("div", null,
                        React.createElement(Button, { type: "default", style: styles.button, onClick: onPauseResume, disabled: stopped || isLoading, block: true },
                            resumePauseIcon,
                            paused ? React.createElement(Trans, { i18nKey: "bulkModalResume" }) : React.createElement(Trans, { i18nKey: "bulkModalPause" }))))),
            React.createElement(Col, { span: 12 },
                React.createElement(Tooltip, { title: stopped ? messageStopped : '' },
                    React.createElement("div", null,
                        React.createElement(Button, { type: "default", style: styles.button, onClick: onStop, disabled: stopped || isLoading, block: true },
                            React.createElement(ImStop, { style: styles.icon }),
                            stopped ? React.createElement(Trans, { i18nKey: "bulkModalStopped" }) : React.createElement(Trans, { i18nKey: "bulkModalStop" }))))))));
};
export default observer(BulkProgressDisplay);
